<main>
  <section
    style="
      background-image: url('assets/images/contact-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Contact Us</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container px-4 my-5 py-5">
    <div class="row g-5">
      <div class="col-md-6">
        <h4 class="text-primary mb-4">Mailing Address</h4>
        <p>
          DFS Insurance
          <br />
          14010 FNB Pkwy Ste. 400
          <br />
          Omaha, NE 68154
        </p>

        <h4 class="text-primary mb-4 mt-5">
          Insurance Information and
          <br />
          General Inquiries
        </h4>
        <p>
          <a class="text-dark text-decoration-none" href="tel:8004443584">
            800.444.3584
          </a>
          <br />
          Monday through Friday, 8:00 AM to 5:00 PM (CST).
        </p>
        <h5 class="text-primary mb-4 mt-5">Claim Information</h5>
        <p>
          <a
            class="text-dark text-decoration-none"
            href="mailto:Claims@dfsinsure.com"
          >
            Claims&#64;dfsinsure.com
          </a>
        </p>
        <h5 class="text-primary mb-4 mt-5">Submit Applications</h5>
        <p>
          <a
            class="text-dark text-decoration-none"
            href="mailto:DACApplications@dfsinsure.com"
          >
            DACApplications&#64;dfsinsure.com
          </a>
        </p>
        <h5 class="text-primary mb-4 mt-5">Policy Renewal Requests</h5>
        <p>
          <a
            class="text-dark text-decoration-none"
            href="mailto:Renewals@dfsinsure.com"
          >
            Renewals&#64;dfsinsure.com
          </a>
        </p>
        <h5 class="text-primary mb-4 mt-5">Policy Changes</h5>
        <p>
          <a
            class="text-dark text-decoration-none"
            href="mailto:PolicyChanges@dfsinsure.com"
          >
            PolicyChanges&#64;dfsinsure.com
          </a>
        </p>
      </div>
      <div class="col-md-6">
        <div class="card p-4">
          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
            <div class="col-12 mb-4">
              <label for="reason" class="form-label">
                Why are you contacting us?
                <span class="text-danger">*</span>
              </label>
              <select
                id="reason"
                formControlName="reason"
                class="form-select fs-6"
                [ngClass]="{
                  'is-invalid':
                    contactForm.controls['reason'].invalid &&
                    contactForm.controls['reason'].touched,
                }"
                required
              >
                <option selected disabled value="">
                  Choose reason for contacting DFS
                </option>
                <option value="1">Claim Related Question</option>
                <option value="2">Policy Renewals or Requests</option>
                <option value="3">Agent Related Question</option>
                <option value="4">General Inquiry</option>
              </select>
              <div
                *ngIf="
                  contactForm.controls['reason'].invalid &&
                  contactForm.controls['reason'].touched
                "
                class="invalid-feedback"
              >
                Please select a reason for contacting us.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label for="name" class="form-label">
                Name
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="name"
                class="form-control fs-6"
                id="name"
                [ngClass]="{
                  'is-invalid':
                    contactForm.controls['name'].invalid &&
                    contactForm.controls['name'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  contactForm.controls['name'].invalid &&
                  contactForm.controls['name'].touched
                "
                class="invalid-feedback"
              >
                Name is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                formControlName="address"
                class="form-control fs-6"
                id="address"
              />
            </div>
            <div class="col-12 mb-4">
              <label for="city" class="form-label">City</label>
              <input
                type="text"
                formControlName="city"
                class="form-control fs-6"
                id="city"
              />
            </div>
            <div class="col-12 mb-4">
              <label for="state" class="form-label">State</label>
              <select
                formControlName="state"
                class="form-select fs-6"
                id="state"
              >
                <option selected disabled value="">Select your state</option>
                <option *ngFor="let s of states" [value]="s.abbreviation">
                  {{ s.name }}
                </option>
              </select>
            </div>
            <div class="col-12 mb-4">
              <label for="zipCode" class="form-label">Zip Code</label>
              <input
                type="text"
                formControlName="zipCode"
                class="form-control fs-6"
                id="zipCode"
              />
            </div>
            <div class="col-12 mb-4">
              <label for="policyNumber" class="form-label">
                Policy Number (if applicable)
              </label>
              <input
                type="text"
                formControlName="policyNumber"
                class="form-control fs-6"
                id="policyNumber"
              />
            </div>
            <div class="col-12 mb-4">
              <label for="email" class="form-label">
                Email address
                <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                formControlName="email"
                class="form-control fs-6"
                id="email"
                [ngClass]="{
                  'is-invalid':
                    contactForm.controls['email'].invalid &&
                    contactForm.controls['email'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  contactForm.controls['email'].invalid &&
                  contactForm.controls['email'].touched
                "
                class="invalid-feedback"
              >
                <span
                  *ngIf="contactForm.controls['email'].errors?.['required']"
                >
                  Email address is required.
                </span>
                <span *ngIf="contactForm.controls['email'].errors?.['email']">
                  Please enter a valid email address.
                </span>
              </div>
            </div>
            <p-messages
              *ngIf="contactSubmitted && contactForm.invalid"
              severity="error"
              [value]="[
                {
                  severity: 'error',
                  detail:
                    'Please correct the validation errors above before submitting.',
                },
              ]"
              [closable]="false"
              class="col-12 mb-4"
            ></p-messages>
            <div class="col-12 mb-4">
              <re-captcha
                (resolved)="getCaptchaValue($event)"
                siteKey="{{ captchaKey }}"
              ></re-captcha>
              <p class="text-danger" *ngIf="contactSubmitted && !captchaIsValid">
                Please validate you are not a robot before submitting.
              </p>
            </div>
            <div class="col-12 mb-4">
              <button type="submit" class="btn btn-primary mt-2">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
